'use strict';

module.exports = {
    desktop: {
        dp: {
            details: [
                'ancillaries_module',
            ],
        },
        flights: {
            details: [
                'ancillaries_module',
            ],
        },
    },
    mobile: {
        dp: {
            passengersinfo: [
                'ancillaries_module',
            ],
        },
        flights: {
            passengersinfo: [
                'ancillaries_module',
            ],
        },
    },
};
